// ** Icons Import
import dashboard from "../../assets/images/logo/dashboard.svg";
import dashboardActive from "../../assets/images/logo/dashboardActive.svg";
import salesData from "../../assets/images/logo/salesData.svg";
import salesDataActive from "../../assets/images/logo/salesDataActive.svg";
import productStock from "../../assets/images/logo/productStock.svg";
import productStockActive from "../../assets/images/logo/productStockActive.svg";
import provisionalStatement from "../../assets/images/logo/provisionalStatement.svg";
import provisionalStatementActive from "../../assets/images/logo/provisionalStatementActive.svg";
import brandwise from "../../assets/images/logo/brandwise.svg";
import brandwiseActive from "../../assets/images/logo/brandwiseActive.svg";
import cnfwise from "../../assets/images/logo/cnfwise.svg";
import cnfwiseActive from "../../assets/images/logo/cnfwiseActive.svg";
import dcregister from "../../assets/images/logo/dcregister.svg";
import dcregisterActive from "../../assets/images/logo/dcregisterActive.svg";
import projections from "../../assets/images/logo/projections.svg";
import projectionsActive from "../../assets/images/logo/projectionsActive.svg";
import onward from "../../assets/images/logo/onward.svg";
import onwardActive from "../../assets/images/logo/onwardActive.svg";
import employees from "../../assets/images/logo/employees.svg";
import employeesActive from "../../assets/images/logo/employeesActive.svg";

const menuCollapsed = JSON.parse(localStorage.getItem("menuCollapsed"));
export const mainRoutes = [
	{
		id: "Dashboard",
		title: "Dashboard",
		icon: (
			<img
				alt=""
				src={dashboardActive}
				style={{
					width: "20px",
					height: "18px",
					marginRight: menuCollapsed ? "20px" : "11px",
					marginLeft: menuCollapsed ? "12px" : "19px",
				}}
			/>
		),
		iconDeActive: (
			<img
				alt=""
				src={dashboard}
				style={{
					width: "20px",
					height: "18px",
					marginRight: menuCollapsed ? "20px" : "11px",
					marginLeft: menuCollapsed ? "12px" : "19px",
				}}
			/>
		),
		navLink: "/dashboard",
	},
	// {
	// 	id: "Projections",
	// 	title: "Projections",
	// 	icon: (
	// 		<img
	// 			alt=""
	// 			src={projectionsActive}
	// 			style={{
	// 				width: "20px",
	// 				height: "18px",
	// 				marginRight: menuCollapsed ? "20px" : "11px",
	// 				marginLeft: menuCollapsed ? "12px" : "19px",
	// 			}}
	// 		/>
	// 	),
	// 	iconDeActive: (
	// 		<img
	// 			alt=""
	// 			src={projections}
	// 			style={{
	// 				width: "20px",
	// 				height: "18px",
	// 				marginRight: menuCollapsed ? "20px" : "11px",
	// 				marginLeft: menuCollapsed ? "12px" : "19px",
	// 			}}
	// 		/>
	// 	),
	// 	navLink: "/projections",
	// },

	{
		id: "Sales Data",
		title: "Sales Data",
		icon: (
			<img
				alt=""
				src={salesDataActive}
				style={{
					width: "20px",
					height: "18px",
					marginRight: menuCollapsed ? "20px" : "11px",
					marginLeft: menuCollapsed ? "12px" : "19px",
				}}
			/>
		),
		iconDeActive: (
			<img
				alt=""
				src={salesData}
				style={{
					width: "20px",
					height: "18px",
					marginRight: menuCollapsed ? "20px" : "11px",
					marginLeft: menuCollapsed ? "12px" : "19px",
				}}
			/>
		),
		navLink: "/salesdata",
	},
	{
		id: "Sales Data Datewise",
		title: "Sales Data (Datewise)",
		icon: (
			<img
				alt=""
				src={salesDataActive}
				style={{
					width: "20px",
					height: "18px",
					marginRight: menuCollapsed ? "20px" : "11px",
					marginLeft: menuCollapsed ? "12px" : "19px",
				}}
			/>
		),
		iconDeActive: (
			<img
				alt=""
				src={salesData}
				style={{
					width: "20px",
					height: "18px",
					marginRight: menuCollapsed ? "20px" : "11px",
					marginLeft: menuCollapsed ? "12px" : "19px",
				}}
			/>
		),
		navLink: "/salesdatadatewise",
	},
	{
		id: "CNF Wise",
		title: "CNF Wise",
		icon: (
			<img
				alt=""
				src={cnfwiseActive}
				style={{
					width: "20px",
					height: "18px",
					marginRight: menuCollapsed ? "20px" : "11px",
					marginLeft: menuCollapsed ? "12px" : "19px",
				}}
			/>
		),
		iconDeActive: (
			<img
				alt=""
				src={cnfwise}
				style={{
					width: "20px",
					height: "18px",
					marginRight: menuCollapsed ? "20px" : "11px",
					marginLeft: menuCollapsed ? "12px" : "19px",
				}}
			/>
		),
		navLink: "/cnf-wise",
	},
	{
		id: "Brand Wise",
		title: "Brand Wise",
		icon: (
			<img
				alt=""
				src={brandwiseActive}
				style={{
					width: "20px",
					height: "18px",
					marginRight: menuCollapsed ? "20px" : "13px",
					marginLeft: menuCollapsed ? "12px" : "19px",
				}}
			/>
		),
		iconDeActive: (
			<img
				alt=""
				src={brandwise}
				style={{
					width: "20px",
					height: "18px",
					marginRight: menuCollapsed ? "20px" : "13px",
					marginLeft: menuCollapsed ? "12px" : "19px",
				}}
			/>
		),
		navLink: "/brand-wise",
	},
	{
		id: "Product Stock",
		title: "Product Stock",
		icon: (
			<img
				alt=""
				src={productStockActive}
				style={{
					width: "20px",
					height: "18px",
					marginRight: menuCollapsed ? "20px" : "11px",
					marginLeft: menuCollapsed ? "12px" : "19px",
				}}
			/>
		),
		iconDeActive: (
			<img
				alt=""
				src={productStock}
				style={{
					width: "20px",
					height: "18px",
					marginRight: menuCollapsed ? "20px" : "11px",
					marginLeft: menuCollapsed ? "12px" : "19px",
				}}
			/>
		),
		navLink: "/product-stock",
	},
	{
		id: "DC Register",
		title: "DC Register",
		icon: (
			<img
				alt=""
				src={dcregisterActive}
				style={{
					width: "20px",
					height: "18px",
					marginRight: menuCollapsed ? "20px" : "11px",
					marginLeft: menuCollapsed ? "12px" : "19px",
				}}
			/>
		),
		iconDeActive: (
			<img
				alt=""
				src={dcregister}
				style={{
					width: "20px",
					height: "18px",
					marginRight: menuCollapsed ? "20px" : "11px",
					marginLeft: menuCollapsed ? "12px" : "19px",
				}}
			/>
		),
		navLink: "/dc-register",
	},
	// {
	// 	id: "Employee Rights",
	// 	title: "Employee Rights",
	// 	icon: (
	// 		<img
	// 			alt=""
	// 			src={employeesActive}
	// 			style={{
	// 				width: "20px",
	// 				height: "18px",
	// 				marginRight: menuCollapsed ? "20px" : "11px",
	// 				marginLeft: menuCollapsed ? "12px" : "19px",
	// 			}}
	// 		/>
	// 	),
	// 	iconDeActive: (
	// 		<img
	// 			alt=""
	// 			src={employees}
	// 			style={{
	// 				width: "20px",
	// 				height: "18px",
	// 				marginRight: menuCollapsed ? "20px" : "11px",
	// 				marginLeft: menuCollapsed ? "12px" : "19px",
	// 			}}
	// 		/>
	// 	),
	// 	navLink: "/employee-rights",
	// },
	//This is commented because unneccesary requests happen in Provisional Statement and Onward Sample Display.
	// {
	// 	id: "Provisional Statement",
	// 	title: "Provisional Statement",
	// 	icon: (
	// 		<img
	// 			alt=""
	// 			src={provisionalStatementActive}
	// 			style={{
	// 				width: "20px",
	// 				height: "18px",
	// 				marginRight: menuCollapsed ? "20px" : "11px",
	// 				marginLeft: menuCollapsed ? "12px" : "19px",
	// 			}}
	// 		/>
	// 	),
	// 	iconDeActive: (
	// 		<img
	// 			alt=""
	// 			src={provisionalStatement}
	// 			style={{
	// 				width: "20px",
	// 				height: "18px",
	// 				marginRight: menuCollapsed ? "20px" : "11px",
	// 				marginLeft: menuCollapsed ? "12px" : "19px",
	// 			}}
	// 		/>
	// 	),
	// 	navLink: "/provisional-statement",
	// },
	// {
	// 	id: "Onward Sample Dispatch",
	// 	title: "Onward Sample Dispatch",
	// 	icon: (
	// 		<img
	// 			alt=""
	// 			src={onwardActive}
	// 			style={{
	// 				width: "20px",
	// 				height: "18px",
	// 				marginRight: menuCollapsed ? "20px" : "11px",
	// 				marginLeft: menuCollapsed ? "12px" : "19px",
	// 			}}
	// 		/>
	// 	),
	// 	iconDeActive: (
	// 		<img
	// 			alt=""
	// 			src={onward}
	// 			style={{
	// 				width: "20px",
	// 				height: "18px",
	// 				marginRight: menuCollapsed ? "20px" : "11px",
	// 				marginLeft: menuCollapsed ? "12px" : "19px",
	// 			}}
	// 		/>
	// 	),
	// 	navLink: "/onward-sample-dispatch",
	// },
];
export const hoadmRoutes = [
	{
		id: "Dashboard",
		title: "Dashboard",
		icon: (
			<img
				alt=""
				src={dashboardActive}
				style={{
					width: "20px",
					height: "18px",
					marginRight: menuCollapsed ? "20px" : "11px",
					marginLeft: menuCollapsed ? "12px" : "19px",
				}}
			/>
		),
		iconDeActive: (
			<img
				alt=""
				src={dashboard}
				style={{
					width: "20px",
					height: "18px",
					marginRight: menuCollapsed ? "20px" : "11px",
					marginLeft: menuCollapsed ? "12px" : "19px",
				}}
			/>
		),
		navLink: "/dashboard",
	},
	// {
	// 	id: "Projections",
	// 	title: "Projections",
	// 	icon: (
	// 		<img
	// 			alt=""
	// 			src={projectionsActive}
	// 			style={{
	// 				width: "20px",
	// 				height: "18px",
	// 				marginRight: menuCollapsed ? "20px" : "11px",
	// 				marginLeft: menuCollapsed ? "12px" : "19px",
	// 			}}
	// 		/>
	// 	),
	// 	iconDeActive: (
	// 		<img
	// 			alt=""
	// 			src={projections}
	// 			style={{
	// 				width: "20px",
	// 				height: "18px",
	// 				marginRight: menuCollapsed ? "20px" : "11px",
	// 				marginLeft: menuCollapsed ? "12px" : "19px",
	// 			}}
	// 		/>
	// 	),
	// 	navLink: "/projections",
	// },
	{
		id: "Sales Data",
		title: "Sales Data",
		icon: (
			<img
				alt=""
				src={salesDataActive}
				style={{
					width: "20px",
					height: "18px",
					marginRight: menuCollapsed ? "20px" : "11px",
					marginLeft: menuCollapsed ? "12px" : "19px",
				}}
			/>
		),
		iconDeActive: (
			<img
				alt=""
				src={salesData}
				style={{
					width: "20px",
					height: "18px",
					marginRight: menuCollapsed ? "20px" : "11px",
					marginLeft: menuCollapsed ? "12px" : "19px",
				}}
			/>
		),
		navLink: "/salesdata",
	},
	{
		id: "Sales Data Datewise",
		title: "Sales Data (Datewise)",
		icon: (
			<img
				alt=""
				src={salesDataActive}
				style={{
					width: "20px",
					height: "18px",
					marginRight: menuCollapsed ? "20px" : "11px",
					marginLeft: menuCollapsed ? "12px" : "19px",
				}}
			/>
		),
		iconDeActive: (
			<img
				alt=""
				src={salesData}
				style={{
					width: "20px",
					height: "18px",
					marginRight: menuCollapsed ? "20px" : "11px",
					marginLeft: menuCollapsed ? "12px" : "19px",
				}}
			/>
		),
		navLink: "/salesdatadatewise",
	},
	{
		id: "CNF Wise",
		title: "CNF Wise",
		icon: (
			<img
				alt=""
				src={cnfwiseActive}
				style={{
					width: "20px",
					height: "18px",
					marginRight: menuCollapsed ? "20px" : "11px",
					marginLeft: menuCollapsed ? "12px" : "19px",
				}}
			/>
		),
		iconDeActive: (
			<img
				alt=""
				src={cnfwise}
				style={{
					width: "20px",
					height: "18px",
					marginRight: menuCollapsed ? "20px" : "11px",
					marginLeft: menuCollapsed ? "12px" : "19px",
				}}
			/>
		),
		navLink: "/cnf-wise",
	},
	{
		id: "Brand Wise",
		title: "Brand Wise",
		icon: (
			<img
				alt=""
				src={brandwiseActive}
				style={{
					width: "20px",
					height: "18px",
					marginRight: menuCollapsed ? "20px" : "13px",
					marginLeft: menuCollapsed ? "12px" : "19px",
				}}
			/>
		),
		iconDeActive: (
			<img
				alt=""
				src={brandwise}
				style={{
					width: "20px",
					height: "18px",
					marginRight: menuCollapsed ? "20px" : "13px",
					marginLeft: menuCollapsed ? "12px" : "19px",
				}}
			/>
		),
		navLink: "/brand-wise",
	},
	{
		id: "Product Stock",
		title: "Product Stock",
		icon: (
			<img
				alt=""
				src={productStockActive}
				style={{
					width: "20px",
					height: "18px",
					marginRight: menuCollapsed ? "20px" : "11px",
					marginLeft: menuCollapsed ? "12px" : "19px",
				}}
			/>
		),
		iconDeActive: (
			<img
				alt=""
				src={productStock}
				style={{
					width: "20px",
					height: "18px",
					marginRight: menuCollapsed ? "20px" : "11px",
					marginLeft: menuCollapsed ? "12px" : "19px",
				}}
			/>
		),
		navLink: "/product-stock",
	},
	{
		id: "DC Register",
		title: "DC Register",
		icon: (
			<img
				alt=""
				src={dcregisterActive}
				style={{
					width: "20px",
					height: "18px",
					marginRight: menuCollapsed ? "20px" : "11px",
					marginLeft: menuCollapsed ? "12px" : "19px",
				}}
			/>
		),
		iconDeActive: (
			<img
				alt=""
				src={dcregister}
				style={{
					width: "20px",
					height: "18px",
					marginRight: menuCollapsed ? "20px" : "11px",
					marginLeft: menuCollapsed ? "12px" : "19px",
				}}
			/>
		),
		navLink: "/dc-register",
	},
	{
		id: "Employee Rights",
		title: "Employee Rights",
		icon: (
			<img
				alt=""
				src={employeesActive}
				style={{
					width: "20px",
					height: "18px",
					marginRight: menuCollapsed ? "20px" : "11px",
					marginLeft: menuCollapsed ? "12px" : "19px",
				}}
			/>
		),
		iconDeActive: (
			<img
				alt=""
				src={employees}
				style={{
					width: "20px",
					height: "18px",
					marginRight: menuCollapsed ? "20px" : "11px",
					marginLeft: menuCollapsed ? "12px" : "19px",
				}}
			/>
		),
		navLink: "/employee-rights",
	},
	//This is commented because unneccesary requests happen in Provisional Statement and Onward Sample Display.
	// {
	// 	id: "Provisional Statement",
	// 	title: "Provisional Statement",
	// 	icon: (
	// 		<img
	// 			alt=""
	// 			src={provisionalStatementActive}
	// 			style={{
	// 				width: "20px",
	// 				height: "18px",
	// 				marginRight: menuCollapsed ? "20px" : "11px",
	// 				marginLeft: menuCollapsed ? "12px" : "19px",
	// 			}}
	// 		/>
	// 	),
	// 	iconDeActive: (
	// 		<img
	// 			alt=""
	// 			src={provisionalStatement}
	// 			style={{
	// 				width: "20px",
	// 				height: "18px",
	// 				marginRight: menuCollapsed ? "20px" : "11px",
	// 				marginLeft: menuCollapsed ? "12px" : "19px",
	// 			}}
	// 		/>
	// 	),
	// 	navLink: "/provisional-statement",
	// },
	// {
	// 	id: "Onward Sample Dispatch",
	// 	title: "Onward Sample Dispatch",
	// 	icon: (
	// 		<img
	// 			alt=""
	// 			src={onwardActive}
	// 			style={{
	// 				width: "20px",
	// 				height: "18px",
	// 				marginRight: menuCollapsed ? "20px" : "11px",
	// 				marginLeft: menuCollapsed ? "12px" : "19px",
	// 			}}
	// 		/>
	// 	),
	// 	iconDeActive: (
	// 		<img
	// 			alt=""
	// 			src={onward}
	// 			style={{
	// 				width: "20px",
	// 				height: "18px",
	// 				marginRight: menuCollapsed ? "20px" : "11px",
	// 				marginLeft: menuCollapsed ? "12px" : "19px",
	// 			}}
	// 		/>
	// 	),
	// 	navLink: "/onward-sample-dispatch",
	// },
];

export const horptRoutes = [
	{
		id: "Dashboard",
		title: "Dashboard",
		icon: (
			<img
				alt=""
				src={dashboardActive}
				style={{
					width: "20px",
					height: "18px",
					marginRight: menuCollapsed ? "20px" : "11px",
					marginLeft: menuCollapsed ? "12px" : "19px",
				}}
			/>
		),
		iconDeActive: (
			<img
				alt=""
				src={dashboard}
				style={{
					width: "20px",
					height: "18px",
					marginRight: menuCollapsed ? "20px" : "11px",
					marginLeft: menuCollapsed ? "12px" : "19px",
				}}
			/>
		),
		navLink: "/dashboard",
	},
	{
		id: "Sales Data",
		title: "Sales Data",
		icon: (
			<img
				alt=""
				src={salesDataActive}
				style={{
					width: "20px",
					height: "18px",
					marginRight: menuCollapsed ? "20px" : "11px",
					marginLeft: menuCollapsed ? "12px" : "19px",
				}}
			/>
		),
		iconDeActive: (
			<img
				alt=""
				src={salesData}
				style={{
					width: "20px",
					height: "18px",
					marginRight: menuCollapsed ? "20px" : "11px",
					marginLeft: menuCollapsed ? "12px" : "19px",
				}}
			/>
		),
		navLink: "/salesdata",
	},
	{
		id: "Brand Wise",
		title: "Brand Wise",
		icon: (
			<img
				alt=""
				src={brandwiseActive}
				style={{
					width: "20px",
					height: "18px",
					marginRight: menuCollapsed ? "20px" : "13px",
					marginLeft: menuCollapsed ? "12px" : "19px",
				}}
			/>
		),
		iconDeActive: (
			<img
				alt=""
				src={brandwise}
				style={{
					width: "20px",
					height: "18px",
					marginRight: menuCollapsed ? "20px" : "13px",
					marginLeft: menuCollapsed ? "12px" : "19px",
				}}
			/>
		),
		navLink: "/brand-wise",
	},
	{
		id: "Product Stock",
		title: "Product Stock",
		icon: (
			<img
				alt=""
				src={productStockActive}
				style={{
					width: "20px",
					height: "18px",
					marginRight: menuCollapsed ? "20px" : "11px",
					marginLeft: menuCollapsed ? "12px" : "19px",
				}}
			/>
		),
		iconDeActive: (
			<img
				alt=""
				src={productStock}
				style={{
					width: "20px",
					height: "18px",
					marginRight: menuCollapsed ? "20px" : "11px",
					marginLeft: menuCollapsed ? "12px" : "19px",
				}}
			/>
		),
		navLink: "/product-stock",
	},
	{
		id: "DC Register",
		title: "DC Register",
		icon: (
			<img
				alt=""
				src={dcregisterActive}
				style={{
					width: "20px",
					height: "18px",
					marginRight: menuCollapsed ? "20px" : "11px",
					marginLeft: menuCollapsed ? "12px" : "19px",
				}}
			/>
		),
		iconDeActive: (
			<img
				alt=""
				src={dcregister}
				style={{
					width: "20px",
					height: "18px",
					marginRight: menuCollapsed ? "20px" : "11px",
					marginLeft: menuCollapsed ? "12px" : "19px",
				}}
			/>
		),
		navLink: "/dc-register",
	},
	// {
	// 	id: "Employee Rights",
	// 	title: "Employee Rights",
	// 	icon: (
	// 		<img
	// 			alt=""
	// 			src={employees}
	// 			style={{
	// 				width: "20px",
	// 				height: "18px",
	// 				marginRight: menuCollapsed ? "20px" : "11px",
	// 				marginLeft: menuCollapsed ? "12px" : "19px",
	// 			}}
	// 		/>
	// 	),
	// 	iconDeActive: (
	// 		<img
	// 			alt=""
	// 			src={employeesActive}
	// 			style={{
	// 				width: "20px",
	// 				height: "18px",
	// 				marginRight: menuCollapsed ? "20px" : "11px",
	// 				marginLeft: menuCollapsed ? "12px" : "19px",
	// 			}}
	// 		/>
	// 	),
	// 	navLink: "/employee-rights",
	// },
	// {
	// 	id: "Provisional Statement",
	// 	title: "Provisional Statement",
	// 	icon: (
	// 		<img
	// 			alt=""
	// 			src={provisionalStatementActive}
	// 			style={{
	// 				width: "20px",
	// 				height: "18px",
	// 				marginRight: menuCollapsed ? "20px" : "11px",
	// 				marginLeft: menuCollapsed ? "12px" : "19px",
	// 			}}
	// 		/>
	// 	),
	// 	iconDeActive: (
	// 		<img
	// 			alt=""
	// 			src={provisionalStatement}
	// 			style={{
	// 				width: "20px",
	// 				height: "18px",
	// 				marginRight: menuCollapsed ? "20px" : "11px",
	// 				marginLeft: menuCollapsed ? "12px" : "19px",
	// 			}}
	// 		/>
	// 	),
	// 	navLink: "/provisional-statement",
	// },
	// {
	// 	id: "Onward Sample Dispatch",
	// 	title: "Onward Sample Dispatch",
	// 	icon: (
	// 		<img
	// 			alt=""
	// 			src={onwardActive}
	// 			style={{
	// 				width: "20px",
	// 				height: "18px",
	// 				marginRight: menuCollapsed ? "20px" : "11px",
	// 				marginLeft: menuCollapsed ? "12px" : "19px",
	// 			}}
	// 		/>
	// 	),
	// 	iconDeActive: (
	// 		<img
	// 			alt=""
	// 			src={onward}
	// 			style={{
	// 				width: "20px",
	// 				height: "18px",
	// 				marginRight: menuCollapsed ? "20px" : "11px",
	// 				marginLeft: menuCollapsed ? "12px" : "19px",
	// 			}}
	// 		/>
	// 	),
	// 	navLink: "/onward-sample-dispatch",
	// },
];

export default {
	mainRoutes,
	horptRoutes,
	hoadmRoutes,
};
